import React, { useEffect, useState } from 'react';
import Navbar from '../navbar/Navbar';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TablePagination
} from '@mui/material';
import { apiCall } from '../../../service';
import config from '../../config';

const Vehicles = () => {
  const [allVehicleData, setAllVehicleData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          host: config.apiEndpoints.vehicleList.host,
          endPoint: config.apiEndpoints.vehicleList.url,
          method: "GET",
        }
        const response = await apiCall(payload)
        const allVehicleData = response.data.rows.map((data) => ({
          id: data.id,
          vehicleNo: data.vehicle,
          deviceId: data.uid,
          vehicleDetails: data.vehicleinfo,
          gpsUpdatedTime: data.gpsupdatedtime.replace('T', ' ').split('.')[0],
          currentLocation: data.location,
        }));
        setAllVehicleData(allVehicleData);
        setLoading(false)

      } catch (error) {
        console.error('Error fetching data:', error.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setPage(0);
  }, [searchQuery]);

  const filteredVehicles = allVehicleData.filter((vehicle) =>
    vehicle.vehicleNo.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const displayedVehicles = searchQuery ? filteredVehicles : allVehicleData;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <Navbar
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        placeholder="Search vehicle..."
        showFilter={showFilter}
      />
      {
        loading ?
          // <div className='loader_main'>
          //   <div className="loader"></div>
          // </div>
          <div className="loader-wrapper">
            <div className="truck-wrapper">
              <div className="truck">
                <div className="truck-container"></div>
                <div className="glases"></div>
                <div className="bonet"></div>

                <div className="base"></div>

                <div className="base-aux"></div>
                <div className="wheel-back"></div>
                <div className="wheel-front"></div>

                <div className="smoke"></div>
              </div>
            </div>
          </div>
          :
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    "& th": {
                      fontWeight: "bold",
                      fontSize: "17px"
                    }
                  }}
                >
                  <TableCell>ID</TableCell>
                  <TableCell>Vehicle Number</TableCell>
                  <TableCell>Device ID</TableCell>
                  <TableCell>Vehicle Details</TableCell>
                  <TableCell>GPS Updated Time</TableCell>
                  <TableCell>Current Location</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedVehicles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((vehicle) => (
                  <TableRow key={vehicle.id}>
                    <TableCell>{vehicle.id}</TableCell>
                    <TableCell>{vehicle.vehicleNo}</TableCell>
                    <TableCell>{vehicle.deviceId}</TableCell>
                    <TableCell>{vehicle.vehicleDetails}</TableCell>
                    <TableCell>{vehicle.gpsUpdatedTime}</TableCell>
                    <TableCell>{vehicle.currentLocation}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={displayedVehicles.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              labelRowsPerPage="Rows per page"
            />
          </TableContainer>
      }

    </div>
  );
};

export default Vehicles;
